// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectIvsStandardsQueryResult, selectIvsStandardsPageLoading, selectIvsStandardsShowInitWaitingMessage} from '../_selectors/ivs-standard.selectors';

export class IvsStandardsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectIvsStandardsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectIvsStandardsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectIvsStandardsQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
